import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Text,
  VStack,
} from '@chakra-ui/react';

const DeletePaymentModal = ({ isOpen, onClose, onConfirm, payment, loading }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay backdropFilter="blur(4px)" />
      <ModalContent>
        <ModalHeader>Delete Payment</ModalHeader>
        <ModalBody>
          <VStack align="stretch" spacing={4}>
            <Text>Are you sure you want to delete this payment?</Text>
            <Text fontWeight="bold">
              Transaction ID: {payment?.transactionId}
            </Text>
            <Text fontWeight="bold">
              Amount: {payment?.collectedAmount}
            </Text>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose} isDisabled={loading}>
            Cancel
          </Button>
          <Button
            colorScheme="red"
            onClick={onConfirm}
            isLoading={loading}
            loadingText="Deleting...">
            Delete
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DeletePaymentModal;
